// extracted by mini-css-extract-plugin
export default {"container":"Assets_container__4TTba","paginationContainer":"Assets_paginationContainer__ITaoB","nextButton":"Assets_nextButton__wt1iw"};